var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormatListNumbered({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18H21M4 14L4.94036 13.5298C5.57317 13.2134 6.33744 13.3374 6.83772 13.8377V13.8377C7.47963 14.4796 7.47963 15.5204 6.83772 16.1623L4 19H8M4.5 4.5H6V9.5M6 9.5H8M6 9.5H4M12 6H21M12 12H21",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatListNumbered);
export default __webpack_public_path__ + "static/media/formatListNumbered.482ea76b99dc469b41aa81744f3838f7.svg";
export { ForwardRef as ReactComponent };